export const trendingtools2 = [
  {
    name: "Crayon",
    imagesrc:
      "https://uploads-ssl.webflow.com/5ce10a4d0b5f0b560c22e756/62a7a5f5598f972d5e936afb_crayon.jpg",
    link: "https://designstripe.com/crayon",
    description: "Animate your vector illustrations with a few clicks!",
    category: "Illustration",
  },
  {
    name: "Crayon",
    imagesrc:
      "https://uploads-ssl.webflow.com/5ce10a4d0b5f0b560c22e756/62a7a5f5598f972d5e936afb_crayon.jpg",
    link: "https://designstripe.com/crayon",
    description: "Animate your vector illustrations with a few clicks!",
    category: "Illustration",
  },
  {
    name: "Crayon",
    imagesrc:
      "https://uploads-ssl.webflow.com/5ce10a4d0b5f0b560c22e756/62a7a5f5598f972d5e936afb_crayon.jpg",
    link: "https://designstripe.com/crayon",
    description: "Animate your vector illustrations with a few clicks!",
    category: "Illustration",
  },
  {
    name: "Crayon",
    imagesrc:
      "https://uploads-ssl.webflow.com/5ce10a4d0b5f0b560c22e756/62a7a5f5598f972d5e936afb_crayon.jpg",
    link: "https://designstripe.com/crayon",
    description: "Animate your vector illustrations with a few clicks!",
    category: "Illustration",
  },
  {
    name: "Crayon",
    imagesrc:
      "https://uploads-ssl.webflow.com/5ce10a4d0b5f0b560c22e756/62a7a5f5598f972d5e936afb_crayon.jpg",
    link: "https://designstripe.com/crayon",
    description: "Animate your vector illustrations with a few clicks!",
    category: "Illustration",
  },
  {
    name: "Crayon",
    imagesrc:
      "https://uploads-ssl.webflow.com/5ce10a4d0b5f0b560c22e756/62a7a5f5598f972d5e936afb_crayon.jpg",
    link: "https://designstripe.com/crayon",
    description: "Animate your vector illustrations with a few clicks!",
    category: "Illustration",
  },
  {
    name: "Crayon",
    imagesrc:
      "https://uploads-ssl.webflow.com/5ce10a4d0b5f0b560c22e756/62a7a5f5598f972d5e936afb_crayon.jpg",
    link: "https://designstripe.com/crayon",
    description: "Animate your vector illustrations with a few clicks!",
    category: "Illustration",
  },
  {
    name: "Crayon",
    imagesrc:
      "https://uploads-ssl.webflow.com/5ce10a4d0b5f0b560c22e756/62a7a5f5598f972d5e936afb_crayon.jpg",
    link: "https://designstripe.com/crayon",
    description: "Animate your vector illustrations with a few clicks!",
    category: "Illustration",
  },
];

export const trendingtools = [
  // {
  //   name: "Claritee",
  //   imagesrc:
  //     "https://uploads-ssl.webflow.com/5ce10a4d0b5f0b560c22e756/62b1e2e6fc0e5705162d54c1_claritee.svg",
  //   link: "https://claritee.io/",
  //   description: "Powerful wireframing for your visual requirements",
  //   category: "",
  // },
  // {
  //   name: "VJ Type",
  //   imagesrc:
  //     "https://uploads-ssl.webflow.com/5ce10a4d0b5f0b560c22e756/62b1e268e0af128d1d437506_vj-type.svg",
  //   link: "https://vj-type.com/",
  //   description:
  //     "An independant type foundry drawing custom fonts with artistic gesture and sensibility.",
  //   category: "",
  // },

  //
  // {
  //   link: "https://www.podia.com/",
  //   imagesrc:
  //     "https://uploads-ssl.webflow.com/5ce10a4d0b5f0b560c22e756/62b1e1d1091712bbc530033f_podia.svg",
  //   name: "Podia",
  //   description:
  //     "Build websites, sell courses and digital products, and host communities.",
  //   category: "",
  // },
  // {
  //   link: "https://goodpalette.io/",
  //   imagesrc:
  //     "https://uploads-ssl.webflow.com/5ce10a4d0b5f0b560c22e756/62a7a7cdadd1bc34abf7fd98_goodpalette.jpg",
  //   name: "Goodpalette",
  //   description: "A color palette generator specifically built for UI design.",
  //   category: "",
  // },

  // {
  //   link: "https://designstripe.com/crayon",
  //   imagesrc:
  //     "https://uploads-ssl.webflow.com/5ce10a4d0b5f0b560c22e756/62a7a5f5598f972d5e936afb_crayon.jpg",
  //   name: "Crayon",
  //   description: "Animate your vector illustrations with a few clicks",
  //   category: "",
  // },

  // {
  //   link: "https://www.ethicaldesignresources.com/",
  //   imagesrc:
  //     "https://uploads-ssl.webflow.com/5ce10a4d0b5f0b560c22e756/629f418e84a3fe4731dd8af3_ethical-design-resources.gif",
  //   name: "Ethical Design Resources",
  //   description: "Guidance for designing ethically humane digital products.",
  //   category: "",
  // },

  //

  {
    name: "Pixelz AI",
    imagesrc:
      "https://ik.imagekit.io/6djsamqli/Trending-tools/PixelsAI_gNf_VbB8E.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1656098756626",
    link: "https://pixelz.ai/",
    description:
      "Create unique artwork using words, captions, phrases, images & presets.",
  },

  {
    link: "https://www.bueno.art/",
    imagesrc:
      "https://ik.imagekit.io/6djsamqli/Trending-tools/Beuno_OlebBWcQK.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1656098755310",
    name: "Bueno",
    description: "No-Code Tools for NFT Creators.",
  },

  {
    link: "https://www.designmaestro.io/",
    imagesrc:
      "https://ik.imagekit.io/6djsamqli/Trending-tools/DesignMaestro_Y_-K2FjVB.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1656098755500",
    name: "Design Maestro",
    description: "Automate tasks that you repeat hundreds of times each day.",
  },

  {
    link: "https://uicoach.io/",
    imagesrc:
      "https://ik.imagekit.io/6djsamqli/Trending-tools/UICoach_2EDum0nBl.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1656098757347",
    name: "UI Coach",
    description:
      "Improve your UI/UX Design skills by designing real-world projects.",
  },

  {
    link: "https://openui.design/",
    imagesrc:
      "https://ik.imagekit.io/6djsamqli/Trending-tools/OpenArt_lRd6380gv.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1656098756222",
    name: "Open Art",
    description:
      "Create stunning NFTs applications with bulletproof guidelines and thoughtful more than 50+ components.",
  },

  {
    link: "https://www.glorify.com/template-design/mockup-tool",
    imagesrc:
      "https://ik.imagekit.io/6djsamqli/Trending-tools/Glorify_yUUujb7fZk.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1656098756002",
    name: "Glorify Mockups",
    description:
      "Create stunning mockups to bring your designs to life with beautiful.",
  },

  {
    link: "https://sessions.us/",
    imagesrc:
      "https://ik.imagekit.io/6djsamqli/Trending-tools/Sessions_A-W8sJjb1.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1656098757118",
    name: "Sessions",
    description:
      "Sessions redesigns video call communication by combining all collaboration tools in one place.",
  },
  {
    link: "https://www.campsite.design/",
    imagesrc:
      "https://ik.imagekit.io/6djsamqli/Trending-tools/Campsite_VUY1OdWfQ.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1656098755280",
    name: "Campsite",
    description: "The home for your design team's work-in-progress",
  },
];
